// @flow
import React from 'react';

const Blocks = () => (
  <section className="contact-blocks-section">
    <div className="blocks-inner">
      <div className="block">
        <h3>Support</h3>
        <p>
          Any questions or problems?
          <br />
          <a href="mailto:support@path.net">Contact Support Center</a>
        </p>
      </div>
      <div className="block">
        <h3>Sales</h3>
        <p>
          Interested in our solutions?
          <br />
          <a href="mailto:sales@path.net">Contact Sales</a>
        </p>
      </div>
      <div className="block">
        <h3>Job Openings</h3>
        <p>
          Interested in working for us?
          <br />
          <a href="mailto:jobs@path.net">Contact Team</a>
        </p>
      </div>
    </div>
  </section>
);

export default Blocks;



// WEBPACK FOOTER //
// ./src/components/contact/blocks.js